import { useEffectiveAccess } from '@/api/queries'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'

export function ProfileScreen() {
  const q = useEffectiveAccess()
  if (q.isLoading) return <div className="page"><p>Loading…</p></div>
  const me = q.data
  if (!me) return <div className="page"><p>Not signed in.</p></div>

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Profile &amp; session</h1>
          <p>Your full identity record — useful for support debugging.</p>
        </div>
        <Button onClick={() => {/* TODO: MSAL.logout() */}}>Sign out</Button>
      </div>
      <div className="stack-16">
        <div className="card pad">
          <div className="section-title">Identity (Entra ID)</div>
          <Row k="display name">{me.upn.split('@')[0]}</Row>
          <Row k="UPN"><span className="mono">{me.upn}</span></Row>
          <Row k="object id (oid)"><span className="mono">{me.oid}</span></Row>
          <Row k="tenant"><span className="mono">spiinc.net</span> · production</Row>
        </div>
        <div className="card pad">
          <div className="section-title">Resolved access</div>
          <Row k="effective role"><Badge tone="info">{me.effectiveRole}</Badge></Row>
          <Row k="effective roles">{me.effectiveRoles.map((r) => <Badge key={r} tone="neutral">{r}</Badge>)}</Row>
          <Row k="persona ACL scope">{me.aclScope ? me.aclScope.join(', ') : <span className="muted">all personas</span>}</Row>
          <Row k="capabilities">
            <div className="row" style={{ flexWrap: 'wrap', gap: 6 }}>
              {me.capabilities.map((c) => <Badge key={c} tone="neutral">{c}</Badge>)}
            </div>
          </Row>
        </div>
      </div>
    </div>
  )
}

function Row({ k, children }: { k: string; children: any }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: 'var(--sp-16)', padding: 'var(--sp-8) 0', borderBottom: '1px solid var(--stroke-1)', alignItems: 'center' }}>
      <div className="muted" style={{ fontSize: 'var(--fs-200)' }}>{k}</div>
      <div style={{ fontSize: 'var(--fs-300)' }}>{children}</div>
    </div>
  )
}
